import { GenericActions } from './generic'
import { ActiveActionlessActions } from './actionless'

export type ActiveActions = GenericActions | ActiveActionlessActions

export * from './generic'
